/* eslint-disable camelcase */
import { TeamMemberStatusType, TeamRoleType } from "@teaming/common-enums";

export default {
	//
	// AssessmentDialog
	//
	AssessmentDialog_title: "Work Style Assessment",

	//
	// Assessment Prompt
	//
	AssessmentPrompt_thisUserDescription1: "Teaming’s work style assessments provides valuable insights into your unique tendencies and strengths as a leader and teammate.",
	AssessmentPrompt_thisUserDescription2: "Once you complete your work style assessment, we’ll show a brief overview here for quick comparison with your teammate in this 1:1.",
	AssessmentPrompt_otherUserDescription1a: "Once {name} takes the work style assessment, we’ll show you a full breakdown of their work style here, along with some tips on the best ways to communicate with, coach, and motivate as you work together.",
	AssessmentPrompt_otherUserDescription1b: "Once they take the work style assessment, we’ll show you a full breakdown of their work style here, along with some tips on the best ways to communicate with, coach, and motivate as you work together.",
	AssessmentPrompt_takeAssessmentButton: "Take the assessment now",
	AssessmentPrompt_remindButton1: "Remind {name} to take the assessment",
	AssessmentPrompt_remindButton2: "Remind them to take the assessment",
	AssessmentPrompt_yourSkeletonHeading1: "What comes naturally to you",
	AssessmentPrompt_yourSkeletonHeading2: "What energizes you",
	AssessmentPrompt_yourSkeletonHeading3: "What drains you",
	AssessmentPrompt_theirSkeletonHeading1a: "What comes naturally to {name}",
	AssessmentPrompt_theirSkeletonHeading1b: "What comes naturally to them",
	AssessmentPrompt_theirSkeletonHeading2a: "What energizes {name}",
	AssessmentPrompt_theirSkeletonHeading2b: "What energizes them",
	AssessmentPrompt_theirSkeletonHeading3a: "What drains {name}",
	AssessmentPrompt_theirSkeletonHeading3b: "What drains them",
	AssessmentPrompt_reminderConfirmation: "A reminder has been sent to {name}.",

	//
	// OneOnOneListPlaceholder
	//
	OneOnOneListPlaceholder_title: "You have no active 1:1s",
	OneOnOneListPlaceholder_subtitle: "1:1s give you all the tools you need to foster healthy, productive relationships on your team.",
	OneOnOneListPlaceholder_createButton: "Create a new 1:1",

	//
	// OneOnOneListCard
	//
	[ `OneOnOneListCard_teamMemberStatusType${ TeamMemberStatusType.ACTIVE }` ]: "Active",
	[ `OneOnOneListCard_teamMemberStatusType${ TeamMemberStatusType.INVITED }` ]: "Invited",
	[ `OneOnOneListCard_teamMemberStatusType${ TeamMemberStatusType.DEFERRED }` ]: "Not yet invited",
	[ `OneOnOneListCard_teamRoleType${ TeamRoleType.LEAD }` ]: "Lead",
	[ `OneOnOneListCard_teamRoleType${ TeamRoleType.MEMBER }` ]: "Member",
	[ `OneOnOneListCard_teamRoleType${ TeamRoleType.MANAGER }` ]: "Manager",
	[ `OneOnOneListCard_teamRoleType${ TeamRoleType.REPORT }` ]: "Report",
	[ `OneOnOneListCard_teamRoleType${ TeamRoleType.PEER }` ]: "Peer",

	//
	// DeferredInvitationBanner
	//
	DeferredInvitationBanner_deferredInviteNotificationText: "Your teammate for this 1:1 hasn't been invited.",
	DeferredInvitationBanner_successfulInviteNotificationText: "Your invitation has been sent.",
	DeferredInvitationBanner_sendInvitationText: "Send invitation",
};
